import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import moment from "moment";
import history from "../../history";
import CartTitle from "../CartTitle";
import { fetchQueryParams } from "../../utils/comman";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DesignCard from "../DesignCard";

import get from "lodash/get";

const _ = { get };

function UserDetail(props) {
  let { elements } = props;
  const [selectedVehicle, setSelectedVehicle] = useState();
  const [isVehicleSelected, setIsVehicleSelected] = useState(true);
  useEffect(() => {
    let queryParams = props.query;
    if (queryParams === "") {
      history.push(`/user/list`);
    } else {
      const params = fetchQueryParams(props.query);
      props.handleFetchSingleUser({
        cluster: params.cluster,
        guid: params.guid,
      });
      props.handleFetchUserVehicles(params.userId);
      props.handleClearPreviousReducers();
    }
  }, []);

  const handleToVechicle = () => {
    if (props.singleUser !== null) {
      history.push(
        `/user/vechile-onboarding?guid=${props.singleUser.guid}&id=${props.singleUser._id}&cluster=${props.singleUser.cluster}`
      );
    }
  };

  const handleSelectVehicle = (vehicle) => {
    setIsVehicleSelected(false);
    setSelectedVehicle(vehicle);
  };

  const handleBecomeMemberClick = () => {
    history.push(`/user/riders-registration?vehicleId=${selectedVehicle._id}`);
  };

  return (
    <React.Fragment>
      {props.singleUserStatus !== false ? <Loader /> : null}
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "userDetailsElements.headingElement",
                "User Detail"
              )}
              Name={"Filter"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
        </Row>

        <Card className="mb-3">
          {props.singleUser ? (
            <CardBody>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "userDetailsElements.subHeadingElement",
                        "PERSONAL INFORMATION"
                      )}
                    </span>
                  </h2>
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.fNameLabel",
                      "First Name"
                    )}
                    titleName={props.singleUser.fName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.lNameLabel",
                      "Last Name"
                    )}
                    titleName={props.singleUser.lName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.emailLabel",
                      "Email ID"
                    )}
                    titleName={props.singleUser.contactDetails.email}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.mobileNumber",
                      "Phone Number"
                    )}
                    titleName={
                      props.singleUser.contactDetails.mobile.primary.number
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.countryCodeLabel",
                      "Country Code"
                    )}
                    titleName={props.singleUser.locality.country}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.genderLabel",
                      "Gender"
                    )}
                    titleName={props.singleUser.gender}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.dobLabel",
                      "DOB"
                    )}
                    titleName={moment(props.singleUser.dob).format(
                      "DD-MM-YYYY"
                    )}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "userDetailsElements.clusterLabel",
                      "Cluster"
                    )}
                    titleName={props.singleUser.cluster}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "userDetailsElements.vechicleInformationLabel",
                        "VEHICLE INFORMATION"
                      )}
                    </span>
                  </h2>
                </Col>

                {props.userVehicles.length !== 0 ? (
                  props.userVehicles.map((userVehicle, index) => (
                    <Col
                      key={index}
                      xs={12}
                      md={12}
                      sm={12}
                      xl={4}
                      className="mb-3"
                    >
                      <Card className="byk-card">
                        <CardBody className="p-2">
                          <div className="d-flex flex-column">
                            <div className="w-100  ml-auto information px-2 py-2 position-relative">
                              <div className="d-flex flex-column">
                                <span className="text-capitalize d-flex flex-row pr-2">
                                  <span className="mr-2 title">
                                    {_.get(
                                      elements,
                                      "userDetailsElements.motorcyleNameLabel",
                                      "Motorcycle Name - "
                                    )}
                                  </span>
                                  <span className="detail">
                                    {userVehicle.vehicleModelName}
                                  </span>
                                </span>

                                <span className="text-capitalize d-flex flex-row pr-2">
                                  <span className="mr-2 title">
                                    {_.get(
                                      elements,
                                      "userDetailsElements.motorcyleColorLabel",
                                      "Motorcycle Color - "
                                    )}
                                  </span>
                                  <span className="detail">
                                    {userVehicle.vehicleModelColor}
                                  </span>
                                </span>

                                <span className="text-capitalize d-flex flex-row pr-2">
                                  <span className="mr-2 title">
                                    {_.get(
                                      elements,
                                      "userDetailsElements.vinLabel",
                                      "VIN -"
                                    )}
                                  </span>
                                  <span className="detail">
                                    {userVehicle.vin}
                                  </span>
                                </span>

                                <span className="text-capitalize d-flex flex-row pr-2">
                                  <span className="mr-2 title">
                                    {_.get(
                                      elements,
                                      "userDetailsElements.registerationNumberLabel",
                                      "Registration Number -"
                                    )}
                                  </span>
                                  <span className="detail">
                                    {userVehicle.registrationNo}
                                  </span>
                                </span>
                                <span className="text-capitalize d-flex flex-row pr-2">
                                  <span className="mr-2 title">
                                    {_.get(
                                      elements,
                                      "userDetailsElements.purchaseDateLabel",
                                      "Purchase Date -"
                                    )}
                                  </span>
                                  <span className="detail">
                                    {userVehicle.dateOfMfg &&
                                      moment(userVehicle.dateOfMfg).format(
                                        "DD-MM-YYYY "
                                      )}
                                  </span>
                                </span>
                              </div>
                              <CustomButton
                                customType={"button"}
                                name={_.get(
                                  elements,
                                  "memberShipDetailElements.selectMotorcycleButtonElement",
                                  "Select Motorcycle"
                                )}
                                customClass={
                                  "btn-outline-dark bg-none ml-2 btnthemeColor"
                                }
                                customClick={() =>
                                  handleSelectVehicle(userVehicle)
                                }
                              />
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col>
                    <p className="text-center">
                      <strong>
                        {_.get(
                          elements,
                          "userDetailsElements.noVechicleToShowLabel",
                          "No Vehicles To Show"
                        )}
                      </strong>
                    </p>
                  </Col>
                )}
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "userDetailsElements.becomeMemberLabel",
                    "Become a Member"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={handleBecomeMemberClick}
                  customDisable={isVehicleSelected}
                />

                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "userDetailsElements.addVehicleElement",
                    "Add Vehicle"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={
                    props.singleUser.ridersClubMember !== true
                      ? handleToVechicle
                      : () =>
                          toast.error(
                            _.get(
                              elements,
                              "userDetailsElements.alreadyAMemberValidationElement",
                              "Already Member"
                            )
                          )
                  }
                />
              </div>
            </CardBody>
          ) : null}
        </Card>
      </div>
    </React.Fragment>
  );
}

export default UserDetail;
